import axios from "axios";

import { auth } from "@Firebase/firebase";

import { HttpQuery } from "@Types/http";
import { LenderBlogPost } from "@Types/lender_blogposts";

export const getPosts = (
  query?: HttpQuery
): (() => Promise<LenderBlogPost[]>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_blogpost/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return response.data.result?.docs ?? [];
  };
};

export const getBlogPost = (id: string): (() => Promise<LenderBlogPost>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_blogpost/${id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
export const likePost = (id: string): (() => Promise<LenderBlogPost>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_blogpost/${id}`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
